module.exports = __webpack_public_path__ + "static/media/back_btn.997b0599.svg";